import { logEvent, setUserId } from 'firebase/analytics';

import { selectUser } from 'store';

import { useAppSelector } from 'hooks';

import { analytics, analyticsReady } from '../config/firebaseAnalytics';

export const useAnalytics = () => {
  const { userId } = useAppSelector(selectUser);

  return (eventName: string, eventParams?: Record<string, unknown>) => {
    const payload = {
      ...eventParams,
      platform: 'web',
      userId
    };

    // Fast path — analytics ready, fire synchronously (preserves existing call-site
    // semantics and test expectations).
    if (analytics) {
      if (userId) {
        setUserId(analytics, userId);
      }
      logEvent(analytics, eventName, payload);
      return;
    }

    // Race path — Firebase `isSupported()` is async, so events fired during app bootstrap
    // (e.g. token-link auto-login that dispatches `trackLogin('token')` the moment App
    // mounts) would be dropped. Defer until the readiness promise resolves, then forward
    // the same event without modification.
    analyticsReady.then((readyAnalytics) => {
      if (!readyAnalytics) return;
      if (userId) {
        setUserId(readyAnalytics, userId);
      }
      logEvent(readyAnalytics, eventName, payload);
    });
  };
};
